<template>
  <div class="create-repair-support">
    <!-- 故障码查询 -->
    <dtc-search
      :visible="brokenCodeSearchVisible"
      :vehicleId="this.repairSupportObj.vehicleId"
      @modalCancel="hideBrokenCodeModal"
      @modalConfirm="handleBrokenCodeModal"
    ></dtc-search>
    <!-- 技术支持报告查询 -->
    <a-modal
      title="技术支持报告查询"
      :width="1200"
      :bodyStyle="bodyStyle"
      v-model="techSupportNumberVisible"
      @ok="hidetechSupportModal"
      okText="确认"
      cancelText="取消"
    >
      <div class="chejia-search-title-container common-horizontal-between-flex">
        <div class="w-30 common-horizontal-between-flex">
          <div class="w-30">
            <span>经销商代码：</span>
          </div>
          <div class="w-70">
            <span>{{userInfo.code}}</span>
            <!-- <a-input v-model="dealerCode"></a-input> -->
          </div>
        </div>
        <div class="w-30 common-horizontal-between-flex">
          <div class="w-30">
            <span>车架号：</span>
          </div>
          <div class="w-70">
            <!-- <span>{{repairSupportObj.vehicleVin}}</span> -->
            <a-input v-model="repairSupportObj.vehicleVin"></a-input>
          </div>
        </div>
        <div class="w-30 common-horizontal-between-flex">
          <div class="w-30">
            <span>状态：</span>
          </div>
          <div class="w-70">
            <a-select
              style="width:100%;"
              @change="handleClaimDateChange"
              :value="searchTechSupportObj.reportStatus"
            >
              <a-select-option value>请选择</a-select-option>
              <a-select-option v-for="item in technicalStatusList" :key="item.id">{{item.name}}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="w-30">
          <a-button type="primary" @click="searchTechSupportNumber">查询</a-button>
        </div>
      </div>
      <div class="c-h-b-flex m-top-20">
        <a-table
          :width="1200"
          :rowSelection="techSupportSelection"
          :columns="searchTechSupportColumns"
          :dataSource="techSupportObjList"
          :pagination="searchTechSupportPagination"
          @change="handleTechSupportChange"
        ></a-table>
      </div>
    </a-modal>
    <!-- PFS代码查询 -->
    <a-modal
      title="PFS代码查询"
      :width="1000"
      :bodyStyle="bodyStyle"
      v-model="pfsTreeVisible"
      @ok="hidePfsTreeModal"
      okText="确认"
      cancelText="取消"
    >
      <a-tree @select="handlePFScodeClick" :loadData="loadPFScodeData" :treeData="pfsCodeList"></a-tree>
    </a-modal>
    <!-- 症状代码查询 -->
    <a-modal
      title="症状代码查询"
      :width="1000"
      :bodyStyle="bodyStyle"
      v-model="zhengzhuangCodeVisible"
      @ok="hideZhengzhuangCodeModal"
      okText="确认"
      cancelText="取消"
    >
      <a-tree
        @select="handleSymptomCodeClick"
        :loadData="loadSymptomCodeData"
        :treeData="symptomCodeList"
      ></a-tree>
    </a-modal>
    <!-- 主要故障件号查询 -->
    <a-modal
      title="主要故障件号查询"
      :width="1000"
      :bodyStyle="bodyStyle"
      v-model="mainBrokenSliceVisible"
      @ok="hideMainBrokenSliceModal"
      okText="确认"
      cancelText="取消"
    >
      <div class="chejia-search-title-container common-horizontal-between-flex">
        <div class="w-25 common-horizontal-between-flex">
          <div class="w-35">
            <span>配件号：</span>
          </div>
          <div class="w-65">
            <a-input v-model="partCode"></a-input>
          </div>
        </div>
        <div class="w-25 common-horizontal-between-flex">
          <div class="w-35">
            <span>配件名称：</span>
          </div>
          <div class="w-65">
            <a-input v-model="partName"></a-input>
          </div>
        </div>
        <div class="w-25 common-horizontal-between-flex">
          <div class="w-35">
            <span>组件代码：</span>
          </div>
          <div class="w-65">
            <a-input v-model="componentCode"></a-input>
          </div>
        </div>
        <div class="w-20">
          <a-button type="primary" @click="searchMainBrokenPartFake">查询</a-button>
        </div>
      </div>
      <div class="common-horizontal-between-fle h-40 l-h-40"></div>
      <div class="table-container m-top-20">
        <a-table
          :bordered="false"
          :rowSelection="mainBrokenPartsSelection"
          :columns="brokenSliceColumns"
          :dataSource="mainBrokenPartNumberList"
          :pagination="partPagination"
          @change="handlePartTableChange"
        ></a-table>
      </div>
    </a-modal>
    <!-- 车架号查询 -->
    <a-modal
      title="车架号查询"
      :width="1000"
      :bodyStyle="bodyStyle"
      v-model="chejiaNumberVisible"
      @ok="hideCarFrameModal"
      okText="确认"
      cancelText="取消"
    >
      <div class="chejia-search-title-container common-horizontal-between-flex">
        <div class="w-30 common-horizontal-between-flex">
          <div class="w-30">
            <span>车架号：</span>
          </div>
          <div class="w-70">
            <a-input v-model="vehicleVin"></a-input>
          </div>
        </div>
        <div class="w-30 common-horizontal-between-flex">
          <div class="w-30">
            <span>车型代码：</span>
          </div>
          <div class="w-70">
            <a-input v-model="vehicleModelCode"></a-input>
          </div>
        </div>
        <div class="w-30">
          <a-button type="primary" @click="searchVehicle">查询</a-button>
        </div>
      </div>
      <div class="c-h-b-flex m-top-20">
        <a-table
          style="width:100%;"
          :rowSelection="vehicleSelection"
          :columns="chejiaSearchColumns"
          :dataSource="chejiaSearchData"
          :pagination="vehicleSearchPagination"
          @change="handleVehicleTableChange"
        ></a-table>
      </div>
    </a-modal>
    <bread-slice basePath="/repairsupport" :routes="routes"></bread-slice>
    <div class="main-title">
      <span>基本信息</span>
    </div>
    <div class="p-10 bg-white-color">
      <div class="c-h-b-flex" style="align-items:flex-start;">
        <div class="w-45 c-v-a-flex flex-start">
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>报告类别：
              </span>
            </div>
            <div class="w-70 p-5">
              <a-select style="width:100%" @change="handleWarrantyReportTypeChange">
                <a-select-option
                  v-for="item in warrantyReportTypeList"
                  :key="item.id"
                  :value="item.id"
                >{{item.name}}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>标题：
              </span>
            </div>
            <div class="w-70 p-5">
              <a-input v-model="repairSupportObj.subject"></a-input>
            </div>
          </div>-->
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>车架号：
              </span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <a-input-search
                v-model="repairSupportObj.vehicleVin"
                enterButton
                @search="showCarFrameModal"
              ></a-input-search>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>车型代码：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <div class="w-100 text-center">{{repairSupportObj.vehicleModelCode}}</div>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>发动机：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <span>{{repairSupportObj.engine}}</span>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>生产基地：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex text-left">
              <span>{{repairSupportObj.plantName}}</span>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>加装附件：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <a-input v-model="repairSupportObj.attachmentAdded"></a-input>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>里程数：
              </span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <div class="w-50">
                <a-input type="number" maxlength="8" v-model="repairSupportObj.tripCurrent"></a-input>
              </div>
              <div class="w-50 c-h-a-flex">
                <a-radio-group name="radioGroup" @change="handleMileageChange" defaultValue="km">
                  <a-radio value="km">公里</a-radio>
                  <a-radio value="mi">英里</a-radio>
                </a-radio-group>
              </div>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>标题：
              </span>
            </div>
            <div class="w-70 p-5">
              <!-- <span>{{this.repairSupportObj.warrantyReportTypeDictId +'-'+ this.userInfo.code +'-'+ this.repairSupportObj.vehicleVin}}</span> -->
              <!-- <a-input v-model="repairSupportObj.subject"></a-input> -->
              <a-input v-model="title"></a-input>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>功能：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <a-select style="width:100%;" @change="handleFunctionChange">
                <a-select-option
                  v-for="item in functionList"
                  :key="item.id"
                  :value="item.id"
                >{{item.name}}</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>子功能：</span>
            </div>
            <div class="w-70 p-5 c-h-a-flex">
              <a-select style="width:100%;" @change="handleSubFunctionChange">
                <a-select-option
                  :value="item.id"
                  :key="item.id"
                  v-for="item in subFunctionList"
                >{{item.name}}</a-select-option>
              </a-select>
            </div>
          </div>
          <!-- 左半部分结束 -->
        </div>
        <!-- 右半部份开始 -->
        <div class="w-45 c-v-a-flex flex-start">
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>经销商代码：
              </span>
            </div>
            <div class="w-70 p-5">{{userInfo.code}}</div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>经销商名称：</span>
            </div>
            <div class="w-70 p-5">{{userInfo.nameShort}}</div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>联系人职务：
              </span>
            </div>
            <div class="w-70 p-5">
              <a-select style="width:100%;" @change="handlePositionChange">
                <a-select-option
                  v-for="item in positionList"
                  :key="item.tenantRoleId"
                  :value="item.tenantRoleId"
                >{{item.roleName}}</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>联系人：
              </span>
            </div>
            <div class="w-70 p-5">
              <a-select
                :value="repairSupportObj.contactPersonId"
                style="width:100%;"
                @change="handleContactorChange"
              >
                <a-select-option
                  v-for="item in contactorList"
                  :key="item.coreTenantUserId"
                  :value="item.coreTenantUserId"
                >{{item.userName}}</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>
                <span class="nessary-star">*</span>联系人电话：
              </span>
            </div>
            <div class="w-70 p-5">
              <a-input
                @change="handleContactPhoneChange"
                v-model="repairSupportObj.contactPersonTelephone"
                maxlength="11"
              ></a-input>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>联系人电子邮件：</span>
            </div>
            <div class="w-70 p-5">
              <a-input v-model="repairSupportObj.contactPersonEmail"></a-input>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>技术支持报告编号：</span>
            </div>
            <div class="w-70 p-5">
              <a-input-search
                v-model="reportSupportNumber"
                enterButton
                @search="showTechSupportModal"
              ></a-input-search>
            </div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>创建人：</span>
            </div>
            <div class="w-70 text-center">{{avatarValue}}</div>
          </div>
          <div class="h-40 l-h-40 c-h-a-flex form-b-1">
            <div class="w-30 form-bg-color text-right p-right-5">
              <span>创建日期：</span>
            </div>
            <div class="w-70 text-center">
              <span>{{currentDate}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 右半部份结束 -->
    </div>
    <div class="main-title">
      <span>问题描述</span>
    </div>
    <div class="p-10 bg-white-color">
      <div class="c-h-b-flex">
        <div class="w-45 c-h-b-flex form-b-1 h-40 l-h-40">
          <div class="w-30 form-bg-color text-right p-right-5">主要故障件号：</div>
          <div class="w-70 p-5 c-h-b-flex">
            <a-input-search
              v-model="repairSupportObj.partCode"
              enterButton
              @search="showMainBrokenSliceModal"
            ></a-input-search>
          </div>
        </div>
        <div class="w-45 h-40 l-h-40 form-b-1 c-h-b-flex">
          <div class="w-30 text-right form-bg-color">主要故障件名称：</div>
          <div class="w-70">{{repairSupportObj.partName}}</div>
        </div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-45 c-h-b-flex form-b-1 h-40 l-h-40">
          <div class="w-30 form-bg-color text-right p-right-5">症状代码：</div>
          <div class="w-70 p-5 c-h-b-flex">
            <a-input-search
              v-model="repairSupportObj.sysSymptomCode"
              enterButton
              @search="showZhengzhuangCodeModal"
            ></a-input-search>
          </div>
        </div>
        <div class="w-45 h-40 l-h-40 form-b-1 c-h-b-flex">
          <div class="w-30 text-right form-bg-color">症状代码名称：</div>
          <div class="w-70">{{repairSupportObj.sysSymptomName}}</div>
        </div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-45 c-h-b-flex form-b-1 h-40 l-h-40">
          <div class="w-30 form-bg-color text-right p-right-5">组件代码：</div>
          <div class="w-70 p-5 c-h-b-flex">{{repairSupportObj.componentCode}}</div>
        </div>
        <div class="w-45 h-40 l-h-40 form-b-1 c-h-b-flex">
          <div class="w-30 text-right form-bg-color">组件代码名称：</div>
          <div class="w-70">{{repairSupportObj.componentName}}</div>
        </div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-45 c-h-b-flex form-b-1 h-120 l-h-120">
          <div class="w-30 form-bg-color text-right p-right-5">
            <span>
              <span class="nessary-star">*</span>
              问题摘要：
            </span>
          </div>
          <div class="w-70 p-5 c-h-b-flex h-120">
            <a-textarea
              style="height:100%; resize:none;"
              v-model="repairSupportObj.phenomenonSummary"
            ></a-textarea>
          </div>
        </div>
        <div class="w-45 h-120 l-h-120 c-h-b-flex">
          <div class="w-30 form-bg-color text-right p-right-5">
            <span>
              <span class="nessary-star">*</span>
              已维修实施过程：
            </span>
          </div>
          <div class="w-70 p-5 c-h-b-flex h-120">
            <a-textarea style="height:100%;resize:none;" v-model="repairSupportObj.operationDone"></a-textarea>
          </div>
        </div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-45 c-h-b-flex form-b-1 h-40 l-h-40">
          <div class="w-30 form-bg-color text-right p-right-5">失效原因：</div>
          <div class="w-70 p-5 c-h-b-flex">
            <a-select style="width:100%;" @change="handleFailureReasonChange">
              <a-select-option
                v-for="item in failureReasonList"
                :key="item.id"
                :value="item.id"
              >{{item.name}}</a-select-option>
            </a-select>
          </div>
        </div>
        <div class="w-45 h-40 l-h-40 form-b-1 c-h-b-flex">
          <div class="w-30 text-right form-bg-color">PFS代码：</div>
          <div class="w-70 c-h-b-flex">
            <div class="w-50 p-5">
              <a-input-search
                enterButton
                @search="showPfsTreeModal"
                v-model="repairSupportObj.sysPfsCode"
              ></a-input-search>
            </div>
            <div class="w-50 p-5">
              <span>{{repairSupportObj.sysPfsName}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-title">
      <span>故障码</span>
    </div>
    <div class="p-10 bg-white-color">
      <div class="c-h-b-flex">
        <div class="w-25 form-bg-color text-left h-40 l-h-40 p-left-5">
          <span>故障码</span>
        </div>
        <div class="w-40 form-bg-color text-left h-40 l-h-40 p-left-5">
          <span>故障码描述</span>
        </div>
        <div class="w-25 form-bg-color text-left h-40 l-h-40 p-left-5">模块</div>
        <div class="w-10 form-bg-color text-left h-40 l-h-40 p-left-5">操作</div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-25 text-left h-40 l-h-40 p-left-5 c-h-b-flex">
          <a-input-search v-model="brokenCode" enterButton @search="showBrokenCodeSearchModal"></a-input-search>
        </div>
        <div class="w-40 text-left h-40 l-h-40 p-left-5">
          <span>{{brokenDescription}}</span>
        </div>
        <div class="w-25 text-left h-40 l-h-40 p-left-5">{{brokenModule}}</div>
        <div class="w-10 text-left h-40 l-h-40 p-left-5">
          <a-button type="primary" @click="addBrokenCodeToList">添加</a-button>
        </div>
      </div>
      <div class="c-h-b-flex" v-for="(i,index) in repairSupportObj.troubleCodeList" :key="i.id">
        <div class="w-25 text-left h-40 l-h-40 p-left-5 c-h-b-flex">
          <span>{{i.failureCode}}</span>
        </div>
        <div class="w-40 text-left h-40 l-h-40 p-left-5">
          <span>{{i.failureDesc}}</span>
        </div>
        <div class="w-25 text-left h-40 l-h-40 p-left-5">{{i.moduleName}}</div>
        <div class="w-10 text-left h-40 l-h-40 p-left-5">
          <a-button @click="deleteBrokenCode(index)">删除</a-button>
        </div>
      </div>
    </div>
    <div class="main-title">
      <span>附件</span>
    </div>
    <div class="p-10 bg-white-color">
      <div class="c-h-b-flex form-b-1">
        <div class="w-45 c-h-b-flex">
          <div class="w-30 p-left-right-5 form-bg-color text-right h-40 l-h-40">
            <span>附件：</span>
          </div>
          <div class="w-70 p-left-right-5 h-40 l-h-40">
            <a-input placeholder="请填写附件描述" v-model="attachmentDescription"></a-input>
          </div>
        </div>
        <div class="w-45 c-h-b-flex p-left-right-10">
          <input type="file" @change="handleFileUpload" id="attachmentId" />
          <a-button type="primary" @click="uploadFiles" v-if="!finishedUpload">上传</a-button>
          <a-button type="primary" v-else loading>上传</a-button>
        </div>
      </div>
      <div class="c-h-b-flex">
        <div class="w-30 p-left-right-5 text-left h-40 l-h-40 form-bg-color">
          <span>附件名称</span>
        </div>
        <div class="w-30 p-left-right-5 text-left h-40 l-h-40 form-bg-color">
          <span>附件描述</span>
        </div>
        <div class="w-30 c-h-b-flex text-left p-left-right-10 form-bg-color h-40 l-h-40">
          <span>预览</span>
        </div>
        <div class="w-10 text-left form-bg-color h-40 l-h-40">操作</div>
      </div>
      <div
        class="c-h-b-flex m-top-10"
        v-for="(item,index) in repairSupportObj.attachmentList"
        :key="item.id"
      >
        <div class="w-30 p-left-right-5 text-left l-h-40">
          <span>{{item.attachmentName}}</span>
        </div>
        <div class="w-30 p-left-right-5 text-left l-h-40">
          <span>{{item.description}}</span>
        </div>
        <div class="w-30 c-h-b-flex text-left p-left-right-10 l-h-40">
          <template
            v-if="item.attachmentName.includes('PNG')||item.attachmentName.indexOf('jpg')>-1     ||   item.attachmentName.indexOf('png')>-1"
          >
            <img
              @click="downloadFile(item)"
              style="height:60px;cursor:pointer"
              :src="imgPrefix+item.attachmentUrl"
              alt
            />
          </template>
          <template v-else>
            <span>
              不支持预览，请
              <span
                style="text-decoration:underline;cursor:pointer;color:#74003C;"
                @click="downloadFile(item)"
              >下载</span>
            </span>
          </template>
        </div>
        <div class="w-10 text-left l-h-40">
          <a-button type="primary" @click="deleteAttachment(index)">删除</a-button>
        </div>
      </div>
    </div>
    <div class="main-title">
      <span>备注</span>
    </div>
    <div class="p-10 bg-white-color">
      <div class="c-h-b-flex">
        <div class="w-50 c-h-b-flex form-b-1">
          <div class="w-30 form-bg-color h-80 l-h-80 p-left-right-5 text-right">
            <span>备注：</span>
          </div>
          <div class="w-70 h-80 l-h-80 p-5 c-h-b-flex form-b-1">
            <a-textarea style="height:100%;resize:none;" v-model="repairSupportObj.remark"></a-textarea>
          </div>
        </div>
        <div class="w-50"></div>
      </div>
    </div>
    <div class="p-10 m-top-20 m-b-20 c-h-a-flex">
      <div class="c-h-a-flex t-w-150 flex-start">
        <a-button class="m-right-10" @click="resetCreateSupport">重置</a-button>
        <a-button class="m-right-10" type="primary" @click="saveRepairSupport">保存</a-button>
        <a-button
          type="primary"
          @click="createRepairSupport"
          v-if="createRepairSupportDone"
          loading
        >提交</a-button>
        <a-button type="primary" @click="createRepairSupport" v-else>提交</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import breadSlice from "../../components/breadSlice.vue";
import dtcSearch from "../../components/dtcSearch";
import moment from "moment";
import Vue from "vue";
import {
  Form,
  Radio,
  Select,
  Table,
  Modal,
  Tree,
  message,
  Input,
  Button
} from "ant-design-vue";
Vue.use(Form);
Vue.use(Radio);
Vue.use(Select);
Vue.use(Table);
Vue.use(Modal);
Vue.use(Tree);
Vue.use(Input);
Vue.use(Button);

export default {
  data() {
    return {
      currentSymptomCodeItem: "",
      currentPfsCodeItem: "",
      reportTypeName: "",
      title: "",
      reportSupportNumber: "",
      dealerCode: "",
      vehicleCode: "",
      supportType: "",
      avatarValue: Vue.ls.get("username"),
      attachmentDescription: "", //附件描述
      tempBrokenCode: "",
      searchTechSupportColumns: [
        {
          title: "报告编号",
          key: "reportNumber",
          dataIndex: "reportNumber",
          width: 100
        },
        {
          title: "标题",
          key: "subject",
          dataIndex: "subject",
          width: 100
        },
        {
          title: "车架号",
          key: "vin",
          dataIndex: "vin",
          width: 100
        },
        {
          title: "创建日期",
          key: "createTime",
          dataIndex: "createTime",
          width: 150
        },
        {
          title: "最后更新日期",
          key: "updateTime",
          dataIndex: "updateTime",
          width: 150
        },
        {
          title: "状态",
          key: "statusName",
          dataIndex: "statusName",
          width: 100
        },
        // {
        //   title: "里程数",
        //   key: "tripCurrent",
        //   dataIndex: "tripCurrent",
        //   width: 100
        // },
        // {
        //   title: "问题等级",
        //   key: "questionLevel",
        //   dataIndex: "questionLevel",
        //   width: 120
        // },
        // {
        //   title: "症状代码",
        //   key: "sysSymptomCode",
        //   dataIndex: "sysSymptomCode",
        //   width: 120
        // },
        // {
        //   title: "维修请求",
        //   key: "forPreAuthorizationFlag",
        //   dataIndex: "forPreAuthorizationFlag",
        //   width: 120
        // },
        // {
        //   title: "车型年份",
        //   key: "year",
        //   dataIndex: "year",
        //   width: 120
        // },
        // {
        //   title: "主要故障件号",
        //   key: "mainPartCode",
        //   dataIndex: "mainPartCode",
        //   width: 150
        // },
        // {
        //   title: "组件代码",
        //   key: "componentCode",
        //   dataIndex: "componentCode",
        //   width: 150
        // },
        {
          title: "报告类别",
          key: "reportCategory",
          dataIndex: "reportCategory",
          width: 120
        },
        {
          title: "创建人",
          key: "createUserName",
          dataIndex: "createUserName",
          width: 100
        },
        // {
        //   title: "车型代码",
        //   key: "vehicleModelCode",
        //   dataIndex: "vehicleModelCode",
        //   width: 120
        // },
        {
          title: "报告形式",
          key: "reportStyle",
          dataIndex: "reportStyle",
          width: 120
        }
        // {
        //   title: "经销商名称",
        //   key: "dealerName",
        //   dataIndex: "dealerName",
        //   width: 200
        // },
        // {
        //   title: "主功能",
        //   key: "funtion",
        //   dataIndex: "funtion",
        //   width: 100
        // }
      ],
      brokenCodeColumns: [
        {
          key: "dtcModuleDictId",
          dataIndex: "dtcModuleDictId",
          title: "模块"
        },
        {
          key: "code",
          dataIndex: "code",
          title: "故障码"
        },
        {
          key: "description",
          dataIndex: "description",
          title: "故障码描述"
        }
      ],
      brokenCodeSelection: {
        type: "radio",
        onChange: this.brokenCodeSelectionChange
      },
      brokenCodeSearchVisible: false,
      pfsTreeVisible: false,
      zhengzhuangCodeVisible: false,
      brokenSliceColumns: [
        {
          key: "partCode",
          dataIndex: "partCode",
          title: "配件号"
        },
        {
          key: "partName",
          dataIndex: "partName",
          title: "配件名称"
        },
        {
          key: "componentCode",
          dataIndex: "componentCode",
          title: "组件代码"
        }
      ],
      mainBrokenSliceVisible: false,
      mainBrokenPartsSelection: {
        type: "radio",
        onChange: this.mainBrokenPartsSelectionChange
      },
      routes: [
        {
          path: "create",
          breadcrumbName: "保修报告"
        },
        {
          path: "/claim/create",
          breadcrumbName: "新建保修报告"
        }
      ],
      bodyStyle: {},
      vehicleVin: "",
      vehicleModelCode: "",
      chejiaNumberVisible: false,
      techSupportNumberVisible: false,
      vehicleSelection: {
        type: "radio",
        onChange: this.vehicleSelectionChange
      },
      chejiaSearchColumns: [
        {
          key: "vehicleVin",
          dataIndex: "vehicleVin",
          title: "车架号"
        },
        {
          key: "vehicleModelCode",
          dataIndex: "vehicleModelCode",
          title: "车型代码"
        },
        {
          key: "vehicleModelYear",
          dataIndex: "vehicleModelYear",
          title: "年份"
        },
        {
          key: "customerName",
          dataIndex: "customerName",
          title: "车主名称"
        }
      ],
      techSupportSelection: {
        type: "radio",
        onChange: this.techSupportSelectionChange
      },
      partCode: "",
      partName: "",
      componentCode: "",
      brokenCode: "", // 故障码
      brokenDescription: "", //故障码描述
      brokenModule: "", // 故障码模块
      currentFileObj: {
        obj: "",
        name: "",
        type: "",
        description: ""
      }
    };
  },
  methods: {
    saveRepairSupport: function() {
      this.repairSupportObj.reportNumber = this.reportSupportNumber;
      let ids = this.repairSupportObj.troubleCodeList.map(item => item.id);
      Object.assign(this.repairSupportObj, { troubleCodeIds: ids.join(",") });
      if(!this.repairSupportObj.tripUnit){
        this.repairSupportObj.tripUnit = 'km';
      }
      this.$store.dispatch("saveRepairSupportDraft", this.repairSupportObj);
    },
    handleContactPhoneChange: function(e) {
      let value = e.target.value;
      let valueArray = value.split("");
      valueArray.forEach((item, index) => {
        if (item >= 0 && item <= 9) {
          if (item.trim() == 0) {
            valueArray.splice(index, 1, "0");
          }
        } else {
          valueArray.splice(index, 1, "");
        }
      });
      Object.assign(this.repairSupportObj, {
        contactPersonTelephone: valueArray.join("")
      });
    },
    techSupportSelectionChange: function(...arg) {
      arg;
      let [, rowObjArray] = [...arg];
      let rowObj = rowObjArray[0];
      rowObj;
      this.reportSupportNumber = rowObj.reportNumber;
      this.repairSupportObj.technicalSupportId = rowObj.id;
    },
    handleClaimDateChange(value) {
      this.searchTechSupportObj.reportStatus = value;
    },
    searchTechSupportNumber: function() {
      this.searchTechSupportObj.vehicleId = this.vehicle;
      this.searchTechSupportObj.dealerId = this.userInfo.dealerId;
      // this.searchTechSupportObj.reportStatus = this.reportType;
      this.$store.dispatch("searchTechSupport", this.searchTechSupportObj);
    },
    handleTechSupportChange: function(searchTechSupportPagination) {
      let p = {
        current: searchTechSupportPagination.current,
        size: searchTechSupportPagination.pageSize,
        ...this.searchTechSupportObj
      };
      this.$store.dispatch("searchTechSupport", p);
    },
    handlePartTableChange: function(...arg) {
      let [pagination] = [...arg];
      Object.assign(pagination, {
        partCode: this.partCode,
        partName: this.partName,
        componentCode: this.componentCode
      });
      this.$store.dispatch("getMainBrokenPartNumber", pagination);
    },
    downloadFile: function(item) {
      window.open(this.imgPrefix + item.attachmentUrl);
    },
    handleVehicleTableChange: function(...arg) {
      let [pagination] = [...arg];
      console.log(pagination);
      Object.assign(
        pagination,
        { vehicleVin: this.vehicleVin },
        { vehicleModelCode: this.vehicleModelCode }
      );
      this.$store.dispatch("getCarFrameNumber", pagination);
    },
    hideBrokenCodeModal: function() {
      this.brokenCodeSearchVisible = false;
    },
    handleBrokenCodeModal: function(...arg) {
      let [{ obj }] = [...arg];
      obj;
      this.brokenCodeSearchVisible = false;
      console.log(obj.code);
      this.brokenCode = obj.failureCode;
      this.tempBrokenCode = obj;
      this.brokenDescription = obj.failureDesc;
      this.brokenModule = obj.moduleName;
    },
    resetCreateSupport: function() {
      window.location.reload();
    },
    handleContactorChange: function(...arg) {
      let [val] = [...arg];
      let contactorList = this.contactorList.filter(
        item => item.coreTenantUserId === val
      );
      Object.assign(this.repairSupportObj, {
        contactPersonId: contactorList[0].coreTenantUserId
      });
    },
    handlePositionChange: function(...arg) {
      let [val] = [...arg];
      let params = {
        id: val
      };
      Object.assign(this.repairSupportObj, {
        contactPersonPositionId: val
      });
      this.$store.dispatch("searchContactor", params);
      Object.assign(this.repairSupportObj, {
        contactPersonId: ""
      });
    },
    deleteAttachment: function(...arg) {
      arg;
      let [index] = [...arg];
      this.repairSupportObj.attachmentList.splice(index, 1);
    },
    handleFileUpload: function(e) {
      // this.cover = e.target.files[0];
      console.log(e.target.files[0]);
      // const size = Math.floor(e.target.files[0].size / 1000000);
      // console.log(size);
      // if (size > 5) {
      //   this.$Message.error("上传大于5M的文件请开通VIP.");
      //   return;
      // }
      var reader = new FileReader();
      this.currentFileObj.obj = e.target.files[0];
      this.currentFileObj.name = e.target.files[0].name;
      reader.onloadstart = function(e) {
        console.log("开始读取....");
        console.log(e);
      };
      reader.onprogress = function(e) {
        console.log("正在读取中....");
        console.log(e);
      };
      reader.onabort = function(e) {
        console.log("中断读取....");
        console.log(e);
      };
      reader.onerror = function(e) {
        console.log("读取异常....");
        console.log(e);
      };
      let pointer = this;
      pointer;
      reader.onload = (e, pointer) => {
        console.log(e);
        console.log(pointer);
      };
      // reader.onload = function(e, pointer) {
      //   console.log("成功读取....");
      //   //或者 img.src = this.result;  //e.target == this
      //   // document.getElementById("existsImgFile").src = a;
      //   // let formData = new FormData();
      //   console.log(e.target.file[0]);
      //   // formData.append("file");
      //   pointer.currentFileObj.obj = e.target.file[0];
      //   pointer.currentFileObj.name = e.target.file[0].name;
      // };
      // reader.readAsDataURL(this.cover);
    },
    uploadFiles: function() {
      if (this.currentFileObj.obj) {
        let formData = new FormData();
        formData.append("file", this.currentFileObj.obj);
        formData.append("attachmentName", this.currentFileObj.name);
        formData.append("description", this.attachmentDescription);
        this.$store.dispatch("uploadFile", formData);
      } else {
        message.warning("请先选择附件");
      }

      // let tempFileObj = {
      //   attachmentName: this.currentFileObj.name,
      //   description: this.attachmentDescription
      // };
      // this.repairSupportObj.attachmentList.push(tempFileObj);
    },
    deleteBrokenCode: function(...arg) {
      let [index] = [...arg];
      this.repairSupportObj.troubleCodeList.splice(index, 1);
    },
    getBrokenCode: function() {
      this.$store.dispatch("getBrokenCode", {});
    },
    addBrokenCodeToList: function() {
      this.brokenCodeSearchVisible = false;
      let index = this.repairSupportObj.troubleCodeList.findIndex(
        item => item.id === this.tempBrokenCode.id
      );
      if (index < 0 && this.tempBrokenCode.id) {
        this.repairSupportObj.troubleCodeList.push(this.tempBrokenCode);
      }
      this.brokenModule = "";
      this.brokenDescription = "";
      this.brokenCode = "";
    },
    brokenCodeSelectionChange: function(...arg) {
      let [, rowObjArray] = [...arg];
      let rowObj = rowObjArray[0];
      this.tempBrokenCode = rowObj;
      this.brokenCode = rowObj.code;
      this.brokenDescription = rowObj.description;
      this.brokenModule = rowObj.dtcModuleDictId;
    },
    handleDTCModuleChange: function(...arg) {
      let [val] = [...arg];
      val;
    },
    hideBrokenCodeSearchModal: function() {
      this.brokenCodeSearchVisible = false;
    },
    showBrokenCodeSearchModal: function() {
      this.moduleDictId = "";
      this.failureCode = "";
      this.failureDesc = "";
      this.$store.commit("CLEAR_BROKEN_CODE_LIST");
      if(!this.repairSupportObj.vehicleVin){
        message.warning("请选择车架号");
        return
      }else {
        this.brokenCodeSearchVisible = true;
      }
    },
    loadPFScodeData: function(treeNode) {
      return new Promise(resolve => {
        let data = treeNode.dataRef.id;
        console.log(`node id: ${data}`);
        this.$store.dispatch("getPFScode", { id: data });
        setTimeout(() => {
          if (this.globalPFScodeList.length > 0) {
            treeNode.dataRef.children = this.globalPFScodeList;
          }
          resolve();
        }, 1000);
      });
    },
    handlePFScodeClick: function(selectedKeys, e) {
      console.log(selectedKeys);
      console.log(selectedKeys[0]);
      console.log(e.node.dataRef.name);
      this.currentPfsCodeItem = e.node.dataRef;
    },
    showPfsTreeModal: function() {
      this.pfsTreeVisible = true;
    },
    hidePfsTreeModal: function() {
      if (this.currentPfsCodeItem.isLeaf) {
        Object.assign(this.repairSupportObj, {
          sysPfsName: this.currentPfsCodeItem.name
        });
        Object.assign(this.repairSupportObj, {
          sysPfsId: this.currentPfsCodeItem.id
        });
        Object.assign(this.repairSupportObj, {
          sysPfsCode: this.currentPfsCodeItem.code
        });
        this.pfsTreeVisible = false;
      } else {
        this.pfsTreeVisible = true;
        message.warning("请选择至最底层信息");
      }
    },
    handleFailureReasonChange: function(...arg) {
      let [val] = [...arg];
      Object.assign(this.repairSupportObj, { failureReasonDictId: val });
    },
    loadSymptomCodeData: function(treeNode) {
      return new Promise(resolve => {
        let data = treeNode.dataRef.id;
        console.log(`node id: ${data}`);
        this.$store.dispatch("getSymptomCode", { id: data });
        setTimeout(() => {
          if (this.globalSymptomCodeList.length > 0) {
            treeNode.dataRef.children = this.globalSymptomCodeList;
          }
          resolve();
        }, 1000);
      });
    },
    handleSymptomCodeClick: function(selectedKeys, e) {
      console.log(selectedKeys);
      console.log(selectedKeys[0]);
      console.log(e.node.dataRef.name);
      this.currentSymptomCodeItem = e.node.dataRef;
    },
    showZhengzhuangCodeModal: function() {
      this.zhengzhuangCodeVisible = true;
    },
    hideZhengzhuangCodeModal: function() {
      if (this.currentSymptomCodeItem.isLeaf) {
        Object.assign(this.repairSupportObj, {
          sysSymptomName: this.currentSymptomCodeItem.name
        });
        Object.assign(this.repairSupportObj, {
          sysSymptomId: this.currentSymptomCodeItem.id
        });
        Object.assign(this.repairSupportObj, {
          sysSymptomCode: this.currentSymptomCodeItem.code
        });
        this.zhengzhuangCodeVisible = false;
      } else {
        this.zhengzhuangCodeVisible = true;
        message.warning("请选择至最底层信息");
      }
    },
    showMainBrokenSliceModal: function() {
      this.partCode = "";
      this.partName = "";
      this.componentCode = "";
      this.$store.commit("CLEAR_MAIN_BROKEN_PART_NUMBER_LIST");
      this.mainBrokenSliceVisible = true;
    },
    hideMainBrokenSliceModal: function() {
      this.mainBrokenSliceVisible = false;
    },
    searchMainBrokenPartFake: function() {
      let params = {
        partCode: this.partCode,
        partName: this.partName,
        componentCode: this.componentCode,
        size: 10,
        current: 1
      };
      this.$store.dispatch("getMainBrokenPartNumber", params);
    },
    mainBrokenPartsSelectionChange: function(...arg) {
      arg;
      let [, rowObjArray] = [...arg];
      let rowObj = rowObjArray[0];
      console.log(rowObj);
      Object.assign(this.repairSupportObj, { mainPartId: rowObj.partId });
      Object.assign(this.repairSupportObj, { partCode: rowObj.partCode });
      Object.assign(this.repairSupportObj, { partName: rowObj.partName });
      Object.assign(this.repairSupportObj, {
        componentCode: rowObj.componentCode
      });
      Object.assign(this.repairSupportObj, { componentId: rowObj.componentId });
      Object.assign(this.repairSupportObj, {
        componentName: rowObj.componentName
      });
    },
    handleFunctionChange: function(...arg) {
      let [val] = [...arg];
      Object.assign(this.repairSupportObj, { functionId: val });
      this.$store.dispatch("searchFunction", { id: val });
    },
    handleSubFunctionChange: function(...arg) {
      let [val] = [...arg];
      Object.assign(this.repairSupportObj, {
        subFunctionId: val
      });
    },
    vehicleSelectionChange: function(...arg) {
      arg;
      let [, rowObjArray] = [...arg];
      let rowObj = rowObjArray[0];
      rowObj;
      this.vehicle = rowObj.vehicleId;
      Object.assign(this.repairSupportObj, { vehicleVin: rowObj.vehicleVin });
      Object.assign(this.repairSupportObj, { vehicleId: rowObj.vehicleId });
      Object.assign(this.repairSupportObj, {
        vehicleModelCode: rowObj.vehicleModelCode
      });
      Object.assign(this.repairSupportObj, { plantName: rowObj.plantName });
      Object.assign(this.repairSupportObj, { engine: rowObj.engine });
    },
    hidetechSupportModal: function() {
      this.techSupportNumberVisible = false;
    },
    showTechSupportModal: function() {
      this.techSupportNumberVisible = true;
      // this.$store.dispatch("searchTechSupport", {});
      this.searchTechSupportObj.vehicleId = this.vehicle;
      this.searchTechSupportObj.dealerId = this.userInfo.dealerId;
      this.searchTechSupportObj.reportStatus = "";
      this.$store.dispatch("searchTechSupport", this.searchTechSupportObj);
    },
    hideCarFrameModal: function() {
      if (this.repairSupportObj.warrantyReportTypeDictId !== 834) {
        this.title =
          this.reportTypeName +
          "-" +
          this.userInfo.code +
          "-" +
          this.repairSupportObj.vehicleVin;
      }
      this.chejiaNumberVisible = false;
      this.$store.commit("CLEAR_CAR_FRAME_NUMBER_LIST");
    },
    showCarFrameModal: function() {
      this.chejiaNumberVisible = true;
      this.$store.commit("CLEAR_CAR_FRAME_NUMBER_LIST");
    },
    handleWarrantyReportTypeChange: function(...arg) {
      let [id] = [...arg];
      if (id !== 834) {
        let name1 = this.warrantyReportTypeList.filter(item => item.id === id);
        this.reportTypeName = name1[0].name;
        this.title =
          this.reportTypeName +
          "-" +
          this.userInfo.code +
          "-" +
          this.repairSupportObj.vehicleVin;
      } else {
        this.title = "";
      }
      Object.assign(this.repairSupportObj, { warrantyReportTypeDictId: id });
    },
    createRepairSupport: function() {
      if (!this.repairSupportObj.warrantyReportTypeDictId) {
        message.warning("请选择报告类别");
        return;
      }
      if (!this.repairSupportObj.subject) {
        message.warning("请填写报告标题");
        return;
      }
      if (!this.repairSupportObj.vehicleId) {
        message.warning("请选择车架号");
        return;
      }
      if (!this.repairSupportObj.tripCurrent) {
        message.warning("请填写里程数");
        return;
      }
      if (!(this.repairSupportObj.contactPersonPositionId.toString() != "")) {
        console.log(this.repairSupportObj.contactPersonPositionId);
        message.warning("请选择联系人职务");
        return;
      }
      if (!(this.repairSupportObj.contactPersonId.toString() != "")) {
        message.warning("请选择联系人");
        return;
      }
      if (!this.repairSupportObj.contactPersonTelephone) {
        message.warning("请填写联系人电话");
        return;
      }
      if (!this.repairSupportObj.phenomenonSummary) {
        message.warning("请填写问题摘要");
        return;
      }
      if (!this.repairSupportObj.operationDone) {
        message.warning("请填写维修过程");
        return;
      }
      this.repairSupportObj.reportNumber = this.reportSupportNumber;
      let ids = this.repairSupportObj.troubleCodeList.map(item => item.id);
      Object.assign(this.repairSupportObj, { troubleCodeIds: ids.join(",") });
      if(!this.repairSupportObj.tripUnit){
        this.repairSupportObj.tripUnit = 'km';
      }
      this.$store.dispatch("createRepairSupport", this.repairSupportObj);
    },
    handleMileageChange: function(val) {
      let {
        target: { value }
      } = val;
      Object.assign(this.repairSupportObj, { tripUnit: value });
    },
    searchVehicle: function() {
      this.$store.dispatch("getCarFrameNumber", {
        vehicleVin: this.vehicleVin,
        vehicleModelCode: this.vehicleModelCode,
        size: 10,
        current: 1
      });
    },
    ...mapMutations([])
  },
  mounted() {
    let params = [
      "warrantyReportType",
      "failureReason",
      "module",
      "warrantyStatus",
      "technicalStatus"
    ];
    this.$store.dispatch("getUserInfo");
    setTimeout(() => {
      this.$store.dispatch("getDictType", params.join(","));
    }, 500);
    this.$store.dispatch("searchFunction", { id: "" });
    this.$store.dispatch("getSymptomCode", { id: 0 });
    this.$store.dispatch("getPFScode", { id: 0 });
    this.$store.dispatch("searchPosition");
    for (let val in this.repairSupportObj) {
      let name = this.judgeObjType(this.repairSupportObj[val]);
      switch (name) {
        case "object":
          this.repairSupportObj[val] = {};
          break;
        case "array":
          this.repairSupportObj[val] = [];
          break;
        case "string":
          this.repairSupportObj[val] = "";
          break;
        case "number":
          this.repairSupportObj[val] = "";
          break;
        case "null":
          this.log(val);
          break;
        default:
          break;
      }
    }
  },
  watch: {
    title: function(val) {
      if (val) {
        this.repairSupportObj.subject = val;
      }
    },
    reportSupportNumber: function(val) {
      if (val == "") {
        this.repairSupportObj.reportNumber = "";
      }
    },
    finishedUpload: function(val) {
      if (!val && this.finishedUploadFlag) {
        document.getElementById("attachmentId").value = "";
        this.repairSupportObj.attachmentList.push(this.uploadFileList[0]);
        this.attachmentDescription = "";
        Object.assign(this.currentFileObj, {
          obj: "",
          name: "",
          type: "",
          description: ""
        });
      }
    },
    pfsCodeList: function(val) {
      if (val) {
        console.log("pfs changed...");
        this.pfsCodeList.map(value =>
          Object.assign(value, {
            key: value.id,
            title: value.name,
            children: [],
            isLeaf: value.isLeaf ? true : false
          })
        );
      }
    },
    symptomCodeList: function(val) {
      if (val) {
        console.log("symptomCodeList changed...");
        this.symptomCodeList.map(value =>
          Object.assign(value, {
            key: value.id,
            title: value.name,
            children: [],
            isLeaf: value.isLeaf ? true : false
          })
        );
      }
    }
  },
  computed: {
    // imgPrefix: function() {
    //   return process.env.VUE_APP_STATIC_URL;
    // },
    imgPrefix: function() {
      if(window.location.host.indexOf('workplace')!==-1 || window.location.host.indexOf('dealer.qorosauto.com')!==-1){
         return 'http://it.oss.qorosauto.com/claim/'
      }else{
         return 'http://10.181.2.135:9000/claim/'
      }
    },
    currentDate: function() {
      let m = moment().format("YYYY-MM-DD");
      return m;
    },
    ...mapState({
      createRepairSupportDone: state =>
        state.repairSupport.createRepairSupportDone,
      finishedUpload: state => state.utils.finishedUpload,
      contactorList: state => state.utils.contactorList,
      positionList: state => state.utils.positionList,
      uploadFileList: state => state.utils.uploadFileList,
      brokenCodeList: state => state.utils.brokenCodeList,
      brokenCodePages: state => state.utils.brokenCodePages,
      brokenCodeTotal: state => state.utils.brokenCodeTotal,
      brokenCodeDataSource: state =>
        state.repairSupport.repairSupportObj.troubleCodeList,
      globalPFScodeList: state => state.utils.globalPFScodeList,
      pfsCodeList: state => state.utils.pfsCodeList,
      symptomCodeList: state => state.utils.symptomCodeList,
      globalSymptomCodeList: state => state.utils.globalSymptomCodeList,
      mainBrokenPartNumberList: state => state.utils.mainBrokenPartNumberList,
      functionList: state => state.repairSupport.functionList,
      subFunctionList: state => state.repairSupport.subFunctionList,
      userInfo: state => state.user.userInfo,
      chejiaSearchData: state => state.utils.carFrameNumberList,
      repairSupportObj: state => state.repairSupport.repairSupportObj,
      vehicleSearchPagination: state => state.utils.vehicleSearchPagination,
      partPagination: state => state.utils.partPagination,
      techSupportObjList: state => state.techSupport.techSupportObjList,
      searchTechSupportPagination: state =>
        state.techSupport.searchTechSupportPagination,
      searchTechSupportObj: state => state.techSupport.searchTechSupportObj,
      finishedUploadFlag: state => state.utils.finishedUploadFlag
    }),
    ...mapGetters([
      "warrantyReportTypeList",
      "failureReasonList",
      "dtcModuleList",
      "technicalStatusList"
    ])
  },
  components: { breadSlice, dtcSearch }
};
</script>

<style lang='less'>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
